module.exports = __webpack_public_path__ + "static/img/11.c133740.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/sp/11.png
// module id = cuhU
// module chunks = 0